import {nonBlank} from "../../utils/epic.utils";

export class FormSelectOption {

  public readonly name: string;
  public readonly value: string;
  public translation: string;
  public icon: string | undefined;
  public isHtml: boolean = false;
  // Transient for Typeahead (Type-Search)
  public translatedValue: string | undefined;

  constructor(name: string, value: string) {
    this.name = name;
    this.value = value;
    this.translation = name;
  }

  public useName(): FormSelectOption {
    this.translation = '';
    return this;
  }

  public setIcon(iconName: string): FormSelectOption {
    this.icon = iconName;
    return this;
  }

  public asHtml(): FormSelectOption {
    this.isHtml = true;
    return this;
  }

  public hasTranslation(): boolean {
    return nonBlank(this.translation);
  }

  public hasTranslatedValue(): boolean {
    return this.hasTranslation() && nonBlank(this.translatedValue);
  }
}
